<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-03 14:37:29
 * @FilePath: \gcp-fe\src\app\shop\components\pageFooter.vue
 * @Description: 
-->
<template>
  <!-- <el-emp-footer
    :helpData="helpData"
    :qrCode="qrCode"
    :isShowCopyright="isShowCopyright"
  /> -->
  <div class="el-emp-footer">
    <div class="service ">
      <div class="wrapper">
        <ul class="service-list">
          <li class="service-item">
            <div class="service-unit">
              <i class="icon-ccui-sharing-o" />
              <p class="service-txt" :title="serviceItemData[0]">
                {{ serviceItemData[0] }}
              </p>
            </div>
          </li>
          <li class="service-item">
            <div class="service-unit">
              <i class="icon-ccui-high-quality-service" />
              <p class="service-txt" :title="serviceItemData[1]">
                {{ serviceItemData[1] }}
              </p>
            </div>
          </li>
          <li class="service-item">
            <div class="service-unit">
              <i class="icon-ccui-star-o" />
              <p class="service-txt" :title="serviceItemData[2]">
                {{ serviceItemData[2] }}
              </p>
            </div>
          </li>
          <li class="service-item">
            <div class="service-unit">
              <i class="icon-ccui-rmb-o" />
              <p class="service-txt" :title="serviceItemData[3]">
                {{ serviceItemData[3] }}
              </p>
            </div>
          </li>
          <li class="service-item">
            <div class="service-unit">
              <i class="icon-ccui-promote-o" />
              <p class="service-txt" :title="serviceItemData[4]">
                {{ serviceItemData[4] }}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="divider"></div>
    <div class="help">
      <div class="wrapper">
        <div class="help-list">
          <div class="help-nav" v-for="(item, index) in helpData" :key="index">
            <div>
              <h5 class="help-nav-tit">{{ item.tit }}</h5>
              <ul class="help-nav-con">
                <li v-for="(con, i) in item.list" :key="i">
                  <p v-if="!con.url" style="cursor: default;">
                    {{ con.label }}
                  </p>
                  <div
                    v-if="con.kefu"
                    style="cursor: pointer;"
                    @click="targetUrlKefu(con)"
                  >
                    {{ con.label }}
                  </div>
                  <div
                    v-else-if="con.url"
                    style="cursor: pointer;"
                    @click="targetUrl(con)"
                  >
                    {{ con.label }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="help-nav">
            <div class="help-nav-con qrcode-wrapper">
              <div class="qrcode">
                <img :src="qrCode" alt="" />
              </div>
              <div class="tit">{{ $t("pageFooter.officialWechat") }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="isShowCopyright">
      <div class="divider second"></div>
      <div class="copy-right-wrapper">
        <div class="copy-right">
          <div style="position:relative">
            <img
              :src="sanxing"
              alt=""
              width="22px"
              style="position: absolute;top:-2px;left:-25px"
            />
            Copyright©2022{{ $t("pageFooter.company") }}All rights reserved.
          </div>
          <div class="h-divider"></div>
          <p>
            {{ $t("pageFooter.finalInter") }}：<a
              href="https://beian.miit.gov.cn/"
              style="color: inherit;"
              target="_blank"
              >闽ICP备2022005227号-2</a
            >
            {{ $t("pageFooter.officialEcommerce") }}
          </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
// import { OAuth } from "@/app/shop/api/shopping";
// import Cookies from "js-cookie";
export default {
  data() {
    return {
      qrCode: require("@/basa/assets/images/code.jpg"),
      sanxing: require("@/basa/assets/images/sanxing.png"),
      isShowCopyright: true,
      serviceItemData: [
        this.$t("pageFooter.serviceItemData.resource"), // 资源共享
        this.$t("pageFooter.serviceItemData.service"), // 优质服务
        this.$t("pageFooter.serviceItemData.legalCompliance"), // 合法合规
        this.$t("pageFooter.serviceItemData.costReduction"), // 降本增效
        this.$t("pageFooter.serviceItemData.managementImprovement") // 管理提升
      ],
      helpData: [
        {
          tit: this.$t("pageFooter.helpData.aboutUs"), // 关于我们
          list: [
            {
              label: this.$t("pageFooter.helpData.platformIntroduction"),
              url: "/platformIntroduction"
            }, // 平台简介
            {
              label: this.$t("pageFooter.helpData.contactUs"), // 联系我们
              url: "/contactUs"
            }
            // { label: "相关政策与规范", url: "" }
          ]
        },
        {
          tit: this.$t("pageFooter.helpData.purchase"), // 采购方
          list: [
            {
              label: this.$t("pageFooter.helpData.operationGuidelines"),
              url: "https://ahca.iccec.cn/index"
            } // 操作指引
            // { label: "视频教程", url: "" }
          ]
        },
        {
          tit: this.$t("pageFooter.helpData.cooperation"), // 合作商
          list: [
            {
              label: this.$t("pageFooter.helpData.operationGuidelines"), // 操作指引
              url: "/operationGuide"
              // "https://sp.iccec.cn/operationManual?isJRZL=1&searchType=首页"
            },
            // { label: "视频教程", url: "" },
            {
              label: this.$t("pageFooter.helpData.entryRequirements"), // 入网须知
              url: "/networkAccessNotice"
              // "https://sp.iccec.cn/infoManageNetworkAccess?isJRZL=1&searchType=首页"
            }
          ]
        },
        {
          tit: this.$t("pageFooter.helpData.commonQuestions"), // 常见问题
          list: [
            {
              label: this.$t("pageFooter.helpData.purchaseCommonQuestions"), // 采购方常见问题
              url: "https://ahca.iccec.cn/purchaser-faq"
            },
            {
              label: this.$t("pageFooter.helpData.cooperationCommonQuestions"), // 合作商常见问题
              url: "https://sp.iccec.cn/question?isJRZL=1&searchType=首页"
            }
          ]
        },
        {
          tit: this.$t("pageFooter.helpData.serviceCenter"), // 服务中心
          list: [
            {
              kefu: true,
              label: this.$t("pageFooter.helpData.onlineConsultation"), // 在线咨询
              url: "https://work.weixin.qq.com/kfid/kfca8000d191a60882f"
            },
            // { label: "售后服务", url: "" },
            {
              label: this.$t("pageFooter.helpData.feedback"), // 意见反馈
              url:
                "https://moa.iccec.cn/user-feedback/user-feedback-list/list?a=100112&CODE=75617927d0554808ac4edf9c69a5556e"
            }
            // { label: "文件模板下载", url: "" }
          ]
        }
        // {
        //   tit: "供应链金融中心",
        //   list: [
        //     { label: "操作指引", url: "" },
        //     { label: "常见问题", url: "" }
        //   ]
        // }
      ]
    };
  },
  mounted() {},
  methods: {
    search(kw) {
      console.log(kw);
    },
    targetUrl(row) {
      if (row.url) {
        if (row.url == "/contactUs") {
          this.$router.push({
            path: "/contactUs"
          });
        } else if (row.url == "/platformIntroduction") {
          this.$router.push({
            path: "/platformIntroduction"
          });
        } else if (row.url == "/operationGuide") {
          this.$router.push({
            path: "/operationGuide"
          });
        } else if (row.url == "/networkAccessNotice") {
          this.$router.push({
            path: "/networkAccessNotice"
          });
        } else {
          window.open(row.url, "_blank");
        }
      }
    },
    targetUrlKefu() {
      const zx = document.querySelector(".app-item.zaixian");
      zx && zx.click();
    }
  }
};
</script>

<style scoped lang="scss">
.el-emp-footer .help .wrapper .help-list .help-nav .help-nav-con li div {
  height: 27px;
  font-size: 12px;
  font-weight: 400;
  color: #666;
  line-height: 27px;
  &:hover {
    color: #0089ef !important;
  }
}
.help-list {
  display: flex;
  justify-content: space-between;
  .help-nav {
  }
}
/* 服务项文本溢出处理 */
.el-emp-footer
  .service
  .wrapper
  .service-list
  .service-item
  .service-unit
  .service-txt {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  // max-width: 180px;
  max-width: 80px;
  margin: 0;
  padding: 0;
}
</style>
